import React, {FunctionComponent} from 'react';
import {useIsMobile} from "../../hooks/useIsMobile.hook";
// eslint-disable-next-line @typescript-eslint/no-var-requires
const styles = require('./klResponsiveDialog.component.scss');


interface KlDialogBodyProps {
    className?: string;
    noPadding?: boolean;
    noPaddingBottom?: boolean;
}

export const KlDialogBody: FunctionComponent<KlDialogBodyProps> = props => {
    const isMobile = useIsMobile();
    return (
        <div className={`${styles.klDialogBody} ${props.noPadding ? '' : styles.bodyPadding} ${props.noPaddingBottom ? styles.noPaddingBottom : ''}
         ${isMobile ? styles.isMobile : ''} ${props.className || ''}`}>
            {props.children}
        </div>
    );
};